module.exports = __webpack_public_path__ + "img/case_logo.c9d8ced3.png";